import forEach from "lodash/forEach";
import get from "lodash/get";
import omit from "lodash/omit";
import actionTypes from "./actionTypes";
export const initialState = {};
export default function reducer(state = initialState, action = {}) {
    if (get(action, "type") === actionTypes.SET_AVATAR_DATA) {
        const newState = { ...state };
        forEach(get(action, "data"), item => {
            newState[item.Id] = item.Avatar;
        });
        return newState;
    }
    if (get(action, "type") === actionTypes.REMOVE_AVATAR_DATA) {
        return omit(state, get(action, "ids"));
    }
    return state;
}
